module.exports = __webpack_public_path__ + "img/delete.3bbaa503.svg";